import { Pipe, PipeTransform } from '@angular/core';
import { UserTimelinesModal } from '@wilson/interfaces';
import { filterUserSkippedActivities } from './timeline-filter-user-skipped-activities.fn';

@Pipe({
  name: 'timelineFilterUserSkippedActivities',
  standalone: true,
})
export class TimelineFilterUserSkippedActivitiesPipe implements PipeTransform {
  transform(userTimeline: UserTimelinesModal): UserTimelinesModal {
    return filterUserSkippedActivities(userTimeline);
  }
}
